import { animate, utils, onScroll } from "animejs";

const initSeoListServicesAnimation = () => {
	animate(".heading__split__title", {
		autoplay: onScroll({
			container: ".wp-singular",
			enter: "bottom-=50%",
			leave: "top+=50%",
			sync: true,
			debug: false,
			onEnter: (target) => {
				target.target.classList.add("active");
			},
			onLeave: (target) => {
				target.target.classList.remove("active");
			},
		}),
	});
};

const splitH2 = (h2) => {
	const txt = h2.innerText.split(" ");
	txt.forEach((item, idx) => {
		let newTxt =
			"<span class='heading__split__title__word'>" + item + "</span>";
		txt[idx] = newTxt;
	});
	h2.innerHTML = txt.join("");
};

const SeoListServices = () => {
	const servicesWrapper = document.querySelector(".seo__list-services");
	if (servicesWrapper) {
		servicesWrapper.classList.add("is-split");
		const servicesH2 = servicesWrapper.querySelector("h2");
		if (servicesH2) {
			servicesH2.classList.add("heading__split__title");
			servicesH2.parentNode.classList.add("heading__split");
			splitH2(servicesH2);
		}
		initSeoListServicesAnimation();
	}
};

export { SeoListServices };
